module.exports = __webpack_public_path__ + "img/studio-4.5bea741d.jpg";